import React from "react";
import {
    Button,
    Empty,
    message,
    Row,
    Col,
    Input,
    Modal,
    Pagination,
    Spin,
} from "antd";
import Router from "next/router";
import moment from "moment";
import HostConfig from "$ACTIONS/Host.config";
import CMSOBJ from "$DATA/stage.live.static.id";
import { formatAmount, Cookie, sub } from "$ACTIONS/util";
import { get, post } from "$ACTIONS/TlcRequest";
import { ApiPort, APISETS } from "$ACTIONS/TLCAPI";
import { LEARN_TIME } from "$ACTIONS/constantsData";
import { AppliedDataModal } from "./Modal";
import AppliedHistoryCard from "./AppliedHistoryCard";
import { connect } from "react-redux";
import { promotionActions } from "../../store/promotionSlice";
import { getAppliedHistoryAction } from "../../store/thunk/promotionThunk";
import { GetAppliedHistory } from "../../actions/cmsApi";
import { translate } from "$ACTIONS/Translate";

class MyPromotion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Promotionsdata:[],
            OptionStatus: [], // 筛选状态类别
            isShowLearnMask: false, // 是否显示教程
            selectedValidPopoverIndex: null, // 選擇Popover之valid Promotion index
            selectedInvalidPopoverIndex: null, // 選擇Popover之ivvalid Promotion index
            appliedHistoryList: JSON.parse(
                localStorage.getItem("appliedHistoryList")
            ),

            // news

            BonusAppliedList: [], //全部已申請Promotions

            startDate: moment(new Date())
                .subtract(90, "d")
                .startOf("day")
                .utcOffset(8)
                .format("YYYY-MM-DD HH:mm:ss"),
            endDate: moment(new Date())
                .utcOffset(8)
                .format("YYYY-MM-DDTHH:mm:ss"),
            HideInvalid: true,
            /* 展开取消申请优惠弹窗 */
            ShowCancellPopup: false,
            remark: null,
            remarkKey: null,
            showApplyDataItem: null, // 愈顯示的申請資料
            isShowApplyDataModal: false, //是否顯示申請資料
            cancelPromotionItem: null, //欲取消優惠資料
            pageValidIndex: 1, //valid資料分頁index
            pageInvalidIndex: 1, //invalid資料分頁index
            isRefreshingHistory: false, //是否正在更新history data
        };

        this.BonusClaim = this.BonusClaim.bind(this); // 领取红利
        this.cancelBonusPromotion = this.cancelBonusPromotion.bind(this); // 取消优惠
        this.closeLearn = this.closeLearn.bind(this);
        this.currentSelectTime = "currMonth"; // 默认查询当月
        this.currMonth = moment().format("YYYY年MM月");
        this.lastMonth = moment()
            .month(moment().month() - 1)
            .format("YYYY年MM月");
        this.lastLastMonth = moment()
            .month(moment().month() - 2)
            .format("YYYY年MM月");
        this.status = "3"; // 当前的查询状态State值
    }
    componentDidMount() {
        this.props.setAppliedPromotions(() => {
            this.setState({ isRefreshingHistory: false });
        });
        this.GetBonusHistory();

        let learnStepString = Cookie("learnStep");
        typeof learnStepString === "string" &&
            learnStepString.substr(3, 1) === "0" &&
            this.setState({ isShowLearnMask: true });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.topTabIndex !== this.props.topTabIndex) {
            this.setState({
                selectedValidPopoverIndex: null,
                selectedInvalidPopoverIndex: null,
            });
        }
    }
    componentWillUnmount(){
        this.setState = () => false;
    }
    closeLearn() {
        this.setState({ isShowLearnMask: false });
        // 设置开启的记录
        let LearnArr = Cookie("learnStep").split("");
        LearnArr.splice(3, 1, "1");
        Cookie("learnStep", LearnArr.join(""), { expires: LEARN_TIME });
    }
    cancelBonusPromotion(cancelItem) {
        console.log("cancelItem", cancelItem);
        const data = {
            playerBonusId: cancelItem.playerBonusId,
            bonusId: cancelItem.bonusRuleId,
            remark: this.state.remark,
        };

        // Modal.confirm({
        //     icon: null,
        //     centered: true,
        //     title: "确认撤销",
        //     content: "确认要将此优惠撤销吗？",
        //     okText: "确认撤销",
        //     cancelText: "取消",
        //     onCancel: () => {
        //     },
        //     onOk: () => {
                // this.props.setLoading(true);
                this.setState({ isRefreshingHistory: true });
                post(
                    ApiPort.CancelBonusPromotion,
                    data
                )
                    .then((res) => {
                        if (res.isSuccess) {
                            if (res.result.isSuccess) {
                                message.success(translate("取消优惠成功！"));
                                this.setState({
                                    ShowCancellPopup: false,
                                    remark: null,
                                    remarkKey: null,
                                });
                                this.getDepositlist();
                                this.props.setAppliedPromotions(() => {
                                    this.setState({
                                        isRefreshingHistory: false,
                                    });
                                });
                            } else {
                                this.setState({
                                    ShowCancellPopup: false,
                                    isRefreshingHistory: false,
                                });
                                message.error(res.result.message);
                            }
                        } else {
                            this.setState({ isRefreshingHistory: false });
                            message.error(
                                res.result.message || translate("失败")
                            );
                        }
                    })
                    .catch((error) => {
                        this.setState({ isRefreshingHistory: false });
                        console.log("POSTBonusClaim" + error);
                    });
        //     },
        // });
    }

    /**
     * 领取红利
     * @param {*} id 
     */
    BonusClaim(item) {
        let postData = {
            playerBonusId: item.playerBonusId,
        };
        this.setState({isRefreshingHistory: true})
        post(ApiPort.POSTBonusClaim, postData)
            .then((res) => {
                if (res && res.isSuccess) {
                    if (res.result?.isClaimed) {
                        message.success(res.result?.message);
                        this.props.setAppliedPromotions(() => {
                            this.setState({ isRefreshingHistory: false });
                        });
                    } else {
                        message.error(res.result?.message);
                        this.setState({ isRefreshingHistory: false });
                    }
                }
            })
            .catch((error) => {
                console.log("POSTBonusClaim" + error);
                this.setState({ isRefreshingHistory: false });
            });

        Pushgtagdata("Promotion_MyPromotion​","Claim Prize​","Promotion_MyPromotion_C_Claim","",
            [
                {customVariableKey:"Promotion_MyPromotion_C_Claim_PromotionID_PromotioName",
                customVariableValue: item.playerBonusId + "_" + item.bonusName
            }
        ]);
    }

    /**
	 * @description:获取申请过的列表
	 * @return {*}
  	*/
      GetBonusHistory() {
		let params = {
			startDate: this.state.startDate,
			endDate: this.state.endDate
		};
		this.setState({
			isRefreshingHistory: true
		});
		GetAppliedHistory(params).then((res) => {
			if (res) {
				this.setState({
					Promotionsdata: res
				});
			}
			this.setState({
				isRefreshingHistory: false
			});
		});
	}  

    render() {
        {
            console.log("ValidAppliedList", this.props.ValidAppliedList);
        }
        const {
            ShowCancellPopup,
            remarkKey,
            isShowApplyDataModal,
            showApplyDataItem,
            selectedValidPopoverIndex,
            selectedInvalidPopoverIndex,
            pageValidIndex,
            pageInvalidIndex,
            isRefreshingHistory,
            HideInvalid,
            Promotionsdata
        } = this.state;
        /*---------------------- 
			筛选出失效状态的优惠 
		------------------------*/
		let Invalidstatus = [
			'Expired',
			'Served',
			'Force to served',
			'Canceled',
			'Claimed',
			'Not Eligible',
			'Approved'
		];

		/*---------------------- 
			筛选出正常显示的优惠数据 
		------------------------*/
        let Normalstatus = [ 'Pending', 'Serving', 'Waiting for release', 'Release', 'Processing' ];

		const filterData = (status) => {
			let filterDataList = this.state.Promotionsdata
				? this.state.Promotionsdata.filter((item) => {
						return status.some((n) => n.toLowerCase() === item.status.toLowerCase());
					})
				: [];
			return filterDataList;
		};
		/*---------------- 正常的优惠列表 --------------------*/
		let Normaldata = filterData(Normalstatus);
		/*---------------- 失效的优惠列表 ---------------------*/
		let Invaliddata =filterData(Invalidstatus);

        return (
            <div style={{ minHeight: "250px" }}>
                <Spin
                    style={{ minHeight: "250px" }}
                    spinning={
                        isRefreshingHistory || !Promotionsdata
                    }
                    tip={translate("加载中")}
                >
                    {Promotionsdata &&
                        (Promotionsdata.length ? (
                            <div className="account-wrap">
                                {/* 這裡要放要渲染的資料 圖卡式 */}
                                <div className="valid-list-box">
                                    {Normaldata?.length ? (
                                        <div
                                            className="applied-list-box"
                                            gutter={24}
                                        >
                                            {Normaldata.slice(
                                                (pageValidIndex - 1) * 9,
                                                pageValidIndex * 9
                                            ).map((item, index) => {
                                                return (
                                                    <AppliedHistoryCard
                                                        key={index}
                                                        item={item}
                                                        isValid={true}
                                                        index={index}
                                                        selectedPopoverIndex={
                                                            selectedValidPopoverIndex
                                                        }
                                                        onBonusClaim={
                                                            this.BonusClaim
                                                        }
                                                        onCancelPromotion={() => {
                                                            this.setState({
                                                                ShowCancellPopup: true,
                                                                selectedValidPopoverIndex:
                                                                    null,
                                                                selectedInvalidPopoverIndex:
                                                                    null,
                                                                cancelPromotionItem:
                                                                    item,
                                                            });
                                                        }}
                                                        onCancelPopover={(e) => {
                                                            e.stopPropagation();
                                                            this.setState({
                                                                selectedValidPopoverIndex:
                                                                    null,
                                                                selectedInvalidPopoverIndex:
                                                                    null,
                                                            });
                                                        }}
                                                        onOpenPopover={() => {
                                                            this.setState({
                                                                selectedValidPopoverIndex:
                                                                    index,
                                                                selectedInvalidPopoverIndex:
                                                                    null,
                                                            });
                                                            Pushgtagdata("Promotion_MyPromotion","View Tool Tip​","Promotion_MyPromotion_C_ToolTip​")
                                                        }}
                                                        onOpenAppliedDataModal={(e) => {
                                                            e.stopPropagation();
                                                            this.setState({
                                                                isShowApplyDataModal: true,
                                                                showApplyDataItem:
                                                                    item,
                                                                selectedValidPopoverIndex:
                                                                    null,
                                                                selectedInvalidPopoverIndex:
                                                                    null,
                                                            });
                                                        }}
                                                        openPromotionDetail={()=>{
                                                            //这个是打开优惠详情的modal
                                                            const newpromotion_id = item.promotionId || item.promoId;
                                                            if(newpromotion_id){
                                                                const originalObject  = {...item,promoId:newpromotion_id}
                                                                this.props.setItemPromotionDetail(originalObject)
                                                            }
                                                        }}
                                                    />
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <li className="center">
                                            <Empty
                                                image={
                                                    "/vn/img/icon/img-no-record.svg"
                                                }
                                                className="big-empty-box"
                                                description={translate("您暂无任何优惠纪录，先去优惠页面申请吧!")}
                                            />
                                        </li>
                                    )}
                                    {Normaldata?.length >
                                        9 && (
                                        <Pagination
                                            className="general-pagination"
                                            style={{ textAlign: "left" }}
                                            defaultCurrent={1}
                                            pageSize={9}
                                            onChange={(e) => {
                                                this.setState({
                                                    pageValidIndex: e,
                                                });
                                            }}
                                            total={Normaldata.length}
                                            hideOnSinglePage={true}
                                        />
                                    )}
                                </div>
                                {Invaliddata.length ? (
                                    <div className="invalid-list-box">
                                        {HideInvalid && (
                                            <p>
                                                {translate("要显示已收到、已过期和无效的促销活动，")}
                                                <span
                                                    onClick={() => {
                                                        this.setState({
                                                            HideInvalid:
                                                                !HideInvalid,
                                                        });
                                                        Pushgtagdata("Promotion_MyPromotion​","Toggle to Expired Promotion","Promotion_MyPromotion_C_Expired​")
                                                    }}
                                                >
                                                    {translate("点击这里。")}
                                                </span>
                                            </p>
                                        )}
                                        {!HideInvalid && (
                                            <p>
                                                {translate("要隐藏已收到、已过期和无效的促销活动，")}
                                                <span
                                                    style={{
                                                        margin: " 0 10px 0 0",
                                                    }}
                                                    onClick={() => {
                                                        this.setState({
                                                            HideInvalid:
                                                                !HideInvalid,
                                                        });
                                                    }}
                                                >
                                                    {translate("点击这里。")}
                                                </span>
                                            </p>
                                        )}
                                        <div className="line-distance"></div>
                                        <div
                                            className="invalid-list"
                                            style={{
                                                display: HideInvalid
                                                    ? "none"
                                                    : "grid",
                                            }}
                                        >
                                            {Invaliddata
                                                .map((item, index) => {
                                                    return (
                                                        <AppliedHistoryCard
                                                            key={index}
                                                            item={item}
                                                            isValid={false}
                                                            index={index}
                                                            selectedPopoverIndex={
                                                                selectedInvalidPopoverIndex
                                                            }
                                                            onCancelPromotion={() => {
                                                                this.setState({
                                                                    ShowCancellPopup: true,
                                                                    selectedInvalidPopoverIndex:
                                                                        null,
                                                                    selectedValidPopoverIndex:
                                                                        null,
                                                                    cancelPromotionItem:
                                                                        item,
                                                                });
                                                            }}
                                                            onCancelPopover={(e) => {
                                                                e.stopPropagation();
                                                                this.setState({
                                                                    selectedInvalidPopoverIndex:
                                                                        null,
                                                                    selectedValidPopoverIndex:
                                                                        null,
                                                                });
                                                            }}
                                                            onOpenPopover={() => {
                                                                this.setState({
                                                                    selectedInvalidPopoverIndex:
                                                                        index,
                                                                    selectedValidPopoverIndex:
                                                                        null,
                                                                });
                                                            }}
                                                            onOpenAppliedDataModal={() => {
                                                                this.setState({
                                                                    isShowApplyDataModal: true,
                                                                    showApplyDataItem:
                                                                        item,
                                                                    selectedInvalidPopoverIndex:
                                                                        null,
                                                                    selectedValidPopoverIndex:
                                                                        null,
                                                                });
                                                            }}
                                                            openPromotionDetail={(e)=>{
                                                                console.log("openPromotionDetail",e);
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                            }}
                                                        />
                                                    );
                                                })}
                                        </div>
                                        {/* {HideInvalid === false &&
                                            Invaliddata
                                                .length > 9 && (
                                                <Pagination
                                                    className="general-pagination"
                                                    style={{    
                                                        textAlign: "left",
                                                    }}
                                                    defaultCurrent={1}
                                                    pageSize={9}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            pageInvalidIndex: e,
                                                        });
                                                    }}
                                                    total={Invaliddata.length}
                                                    hideOnSinglePage={true}
                                                />
                                            )} */}
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>
                        ) : (
                            <Empty
                                image={"/vn/img/icon/img-no-record.svg"}
                                className="big-empty-box"
                                description={translate("您暂无任何优惠纪录，先去优惠页面申请吧!")}
                            />
                        ))}

                    <AppliedDataModal
                        isVisible={isShowApplyDataModal}
                        onCancel={() =>
                            this.setState({ isShowApplyDataModal: false })
                        }
                        appliedItem={showApplyDataItem}
                    />
                    {/*-------------------------------取消优惠弹窗 选择取消的原因 -----------------------------------*/}
                    <Modal
                        closable={true}
                        className="Proms"
                        centered
                        title={translate("取消免费投注奖金")}
                        visible={ShowCancellPopup}
                        footer={null}
                        onCancel={() => {
                            this.setState({
                                ShowCancellPopup: false,
                                remarkKey: null,
                                remark: null,
                            });
                        }}
                    >
                        {console.log(
                            "cancelPromotionItem",
                            this.state.cancelPromotionItem
                        )}
                        <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "16px",
                            lineHeight: "20px",
                            color: "#202939,"
                        }}
                        >{translate("取消原因")}</div>
                        <Row>
                            <ul className="cap-list cancell-list">
                                {[
                                    translate("选错优惠"),
                                    translate("存款资料错误"),
                                    translate("流水太多"),
                                    translate("存款未到账"),
                                ].map((val, index) => {
                                    return (
                                        <Col span={12} key={index}>
                                            <li
                                                className="cap-item"
                                                onClick={() => {
                                                    this.setState({
                                                        remarkKey: index,
                                                        remark: val,
                                                    });
                                                }}
                                            >
                                                <div
                                                    className={`cap-item-circle${
                                                        remarkKey === index
                                                            ? " curr"
                                                            : ""
                                                    }`}
                                                />
                                                <div className="padding-left-xs">
                                                    {val}
                                                </div>
                                            </li>
                                        </Col>
                                    );
                                })}
                                <Col span={24} key={4}>
                                    <li
                                        className="cap-item"
                                        onClick={() => {
                                            this.setState({
                                                remarkKey: 4,
                                                remark: translate("其它"),
                                            });
                                        }}
                                    >
                                        <div className={`cap-item-circle${
                                                remarkKey === 4
                                                    ? " curr"
                                                    : ""
                                            }`}
                                        />
                                        <div className="padding-left-xs">
                                            {`${translate("其它")}：`}
                                        </div>
                                        <Input
                                            maxLength={30}
                                            onChange={(e) => {
                                                if (e.target.value.length > 0) {
                                                    this.setState({
                                                        remark: e.target.value,
                                                    });
                                                } else {
                                                    this.setState({
                                                        remark: null,
                                                    });
                                                }
                                            }}
                                            value={remarkKey === 4 ? this.state.remark : ""}
                                        />
                                    </li>
                                </Col>
                            </ul>
                        </Row>

                        <Row gutter={16} justify="center">
                            <Col
                                span={12}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "20px",
                                }}
                            >
                                <button
                                    className={`cancel-btn ${remarkKey?"remarked":""}`}
                                    onClick={() => {
                                        this.setState({
                                            ShowCancellPopup: false,
                                            remarkKey: null,
                                            remark: null,
                                        });
                                    }}
                                >
                                    {translate("取消")}
                                </button>
                            </Col>

                            <Col
                                span={12}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "20px",
                                }}
                            >
                                <button
                                    className="keep-btn"
                                    disabled={
                                        this.state.remarkKey === null &&
                                        this.state.remark === null
                                    }
                                    onClick={() => {
                                        this.cancelBonusPromotion(
                                            this.state.cancelPromotionItem
                                        );
                                    }}
                                   
                                >
                                    {translate("提交")}
                                </button>
                            </Col>
                        </Row>
                    </Modal>
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = function (state) {
    return {
        topTabIndex: state.promotion.topTabIndex,
        appliedPromotions: state.promotion.appliedPromotions,
        ValidAppliedList: state.promotion.ValidAppliedList,
        inValidAppliedList: state.promotion.inValidAppliedList,
    };
};

const mapDispatchToProps = function (dispatch) {
    return {
        changeTab: (i) => {
            dispatch(promotionActions.changeTab(i));
        },
        setAppliedPromotions: (stopLoading) => {
            dispatch(getAppliedHistoryAction(stopLoading));
        },
        setItemPromotionDetail:(item) => {
            dispatch(promotionActions.setItemPromotionDetail(item));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyPromotion);
